import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="py-12 border-t border-white/10 transition-colors duration-300 bg-[#000000]" data-id="element-382">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-383">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-384">
          <div className="md:col-span-2" data-id="element-385">
            <Link to="/" data-id="element-386">
              <img src="https://cdn.magicpatterns.com/uploads/kJHhLj6UwPq3LR5JrpxsMh/NEW_GRAVEL_LOGO.png" alt="253Gravel" className="h-10 w-auto mb-4" style={{
              filter: 'brightness(0) invert(1)'
            }} data-id="element-387" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-388">
              Premium gravel, crushed rock, and aggregate delivery serving
              Tacoma and South King County. Fast, reliable, and transparent.
            </p>
          </div>

          <div data-id="element-389">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-390">
              Contact
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-391">
              <li data-id="element-392">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-393">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-394">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-395">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-396">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-397">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-398">
              Hours
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-399">
              <li className="flex justify-between" data-id="element-400">
                <span data-id="element-401">Mon-Fri:</span>
                <span data-id="element-402">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-403">
                <span data-id="element-404">Saturday:</span>
                <span data-id="element-405">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-406">
                <span data-id="element-407">Sunday:</span>
                <span data-id="element-408">Closed</span>
              </li>
            </ul>
          </div>

          <div data-id="element-409">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-410">
              Service Areas
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-411">
              <li data-id="element-412">Tacoma</li>
              <li data-id="element-413">Puyallup</li>
              <li data-id="element-414">Federal Way</li>
              <li data-id="element-415">Auburn</li>
              <li data-id="element-416">Kent</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-417">
          <p data-id="element-418">
            &copy; {new Date().getFullYear()} 253Gravel. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-419">
            <a href="#" className="hover:text-white transition-colors" data-id="element-420">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-421">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}